import { Box, Button, Tooltip, Typography, Paper } from '@mui/material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import noop from 'src/utilities/noop'
import { processImageFile, uploadImageToS3 } from 'src/v3/utilities/s3'
import {
  fetchLinkedServices,
  selectActiveLinkedService,
  selectLinkedServiceById,
} from '../manage.slice'

export default () => {
  let dispatch = useAppDispatch()
  let activeLinkedService = useAppSelector(selectActiveLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(activeLinkedService),
  )

  let onImageUpload = (id: string, t: any) =>
    axios
      .put('/api/manage/linked-service/image', { id })
      .then((response) => uploadImageToS3(t, response.data))
      .then(() => dispatch(fetchLinkedServices()))

  return (
    <Paper elevation={2} sx={{ overflow: 'hidden' }}>
      <Box sx={{ position: 'relative' }}>
        <Box
          component="img"
          src={linkedService?.imageName}
          alt="Service Logo"
          sx={{
            width: '100%',
            height: 200,
            objectFit: 'cover',
            display: 'block',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <Tooltip title="Upload New Logo">
            <Button
              variant="contained"
              component="label"
              size="small"
              sx={{
                bgcolor: 'rgba(0,0,0,0.7)',
                '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' },
                backdropFilter: 'blur(4px)',
              }}
            >
              <AddPhotoAlternateIcon color="primary" />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                hidden
                onChange={(event) =>
                  processImageFile(event, {
                    onLoadingStart: noop,
                    onLoadingEnd: (t: any) => {
                      onImageUpload(activeLinkedService, t)
                    },
                  })
                }
              />
            </Button>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Service Logo
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Current logo for {linkedService?.name || 'selected service'}
        </Typography>
      </Box>
    </Paper>
  )
}
